export { default as PanelErrorBoundary } from './PanelErrorBoundary';
